import { DataService } from './data-service.service'
import { eraseCookie, setCookie } from './cookie'

const getLoginData = async (url: string) => await DataService.getData(url, 'manual')

const loggedOut = () => {
  eraseCookie('is-logged-in')
}

const loggedIn = (username: string) => {
  setCookie('is-logged-in', encodeURIComponent(username), null)
}

export { getLoginData, loggedOut, loggedIn }
